export default {
  list: [],
  dictList: {}
}